import { render, staticRenderFns } from "./ProjectSidebar.vue?vue&type=template&id=0ecb554c&scoped=true&"
import script from "./ProjectSidebar.vue?vue&type=script&lang=js&"
export * from "./ProjectSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSidebar.vue?vue&type=style&index=0&id=0ecb554c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecb554c",
  null
  
)

export default component.exports